import React, { ReactNode } from 'react';
import { AlertDialogFooter } from '@chakra-ui/react';

interface Props {
  children: ReactNode;
}

export const AlertFooter = ({ children }: Props): JSX.Element => {
  return <AlertDialogFooter>{children}</AlertDialogFooter>;
};
export type { Props as AlertFooterProps };
